"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importStar(require("react"));
var UserSettingsFormItem_1 = __importDefault(require("./UserSettingsFormItem"));
var react_i18next_1 = require("react-i18next");
var UserSettingsForm_module_css_1 = __importDefault(require("./UserSettingsForm.module.css"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var ChangeEmailAddressForm = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var page = (0, useTypedPage_1.default)();
    var defaultProps = { saving: false, saved: false, text: "" };
    var defaultErrors = { password: " ", emailAddress: " ", emailAddressConfirmation: " ", };
    var _a = (0, react_1.useState)(defaultProps), props = _a[0], setProps = _a[1];
    var _b = (0, react_1.useState)(defaultErrors), error = _b[0], setError = _b[1];
    var form = (0, inertia_react_1.useForm)({
        password: "",
        emailAddress: "",
        emailAddressConfirmation: "",
    });
    var validation = function (error) {
        var checkValidation = 0;
        Object.values(error).forEach(function (val) {
            if (val.length > 0) {
                checkValidation += 1;
            }
        });
        return checkValidation;
    };
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var profile, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    profile = {
                        id: page.props.user.id,
                        password: form.data.password,
                        emailAddress: form.data.emailAddress,
                        emailAddressConfirmation: form.data.emailAddressConfirmation,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!!validation(error)) return [3 /*break*/, 3];
                    setProps({ saving: true });
                    return [4 /*yield*/, ApiManager_1.default.updateEmailAddress(profile.id, profile)];
                case 2:
                    response = _a.sent();
                    if (response.message) {
                        try {
                            setProps({ saved: true, saving: false, text: response.errors.password[0] });
                        }
                        catch (_b) {
                            setProps({ saved: true, saving: false, text: response.errors.emailAddress[0] });
                        }
                        setTimeout(function () {
                            setProps({ saved: false });
                        }, 5000);
                    }
                    else {
                        setProps({ saved: true, saving: false, text: response });
                        setTimeout(function () {
                            setProps({ saved: false });
                        }, 3000);
                        window.location.reload();
                    }
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.error("Changing email address failed. Exception: ", e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var inputValidation = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var emailRegEx, _a, id, value;
        return __generator(this, function (_b) {
            event.preventDefault();
            emailRegEx = RegExp("^(?:[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\])$");
            _a = event.target, id = _a.id, value = _a.value;
            switch (id) {
                case "password":
                    setError({
                        password: value.length === 0 ? t("This field cannot be empty") : "",
                        emailAddress: error.emailAddress,
                        emailAddressConfirmation: error.emailAddressConfirmation
                    });
                    break;
                case "emailAddress":
                    setError({
                        password: error.password,
                        emailAddress: value.trim() === "" ? t("This field cannot be empty") : "",
                        emailAddressConfirmation: error.emailAddressConfirmation
                    });
                    setError({
                        password: error.password,
                        emailAddress: emailRegEx.test(value.trim()) ? "" : t("Invalid email address format"),
                        emailAddressConfirmation: error.emailAddressConfirmation
                    });
                    break;
                case "emailAddressConfirmation":
                    setError({
                        password: error.password,
                        emailAddress: value.trim() === "" ? t("This field cannot be empty") : "",
                        emailAddressConfirmation: error.emailAddressConfirmation
                    });
                    setError({
                        password: error.password,
                        emailAddress: error.emailAddress,
                        emailAddressConfirmation: value.trim() !== form.data.emailAddress ? t("The email addresses do not match") : "",
                    });
                    break;
                default:
                    break;
            }
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(inertia_react_1.Head, { title: t("Change Email Address") }),
        react_1.default.createElement(UserSettingsFormItem_1.default, { text: t("Verify Current Password"), id: "password", type: "password", className: form.data.password.length > 0 ? "is-invalid " + UserSettingsForm_module_css_1.default.popUpInputField : UserSettingsForm_module_css_1.default.popUpInputField, required: true, onChange: function (e) { inputValidation(e); form.data.password = e.currentTarget.value; }, error: error.password, labelText: t("(Required)"), dataCy: "verifyCurrentPasswordInput" }),
        react_1.default.createElement(UserSettingsFormItem_1.default, { text: t("New Email Address"), id: "emailAddress", type: "email", className: form.data.emailAddress.length > 0 ? "is-invalid " + UserSettingsForm_module_css_1.default.popUpInputField : UserSettingsForm_module_css_1.default.popUpInputField, required: true, onChange: function (e) { inputValidation(e); form.data.emailAddress = e.currentTarget.value; }, error: error.emailAddress, labelText: t("(Required)"), dataCy: "newEmailAddressInput" }),
        react_1.default.createElement(UserSettingsFormItem_1.default, { text: t("Repeat New Email Address"), id: "emailAddressConfirmation", type: "email", className: form.data.emailAddressConfirmation.length > 0 ? "is-invalid " + UserSettingsForm_module_css_1.default.popUpInputField : UserSettingsForm_module_css_1.default.popUpInputField, required: true, onChange: function (e) { inputValidation(e); form.data.emailAddressConfirmation = e.currentTarget.value; }, error: error.emailAddressConfirmation, labelText: t("(Required)"), dataCy: "repeatNewEmailAddressInput" }),
        react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.popUpButtonContainer },
            props.saved ? react_1.default.createElement("span", { style: { fontFamily: "Geomanist", margin: "auto 1rem" } }, t(props.text)) : null,
            react_1.default.createElement(Button_1.default, { style: { fontSize: "15px", backgroundColor: "var(--secondary-color)" }, className: props.saving || validation(error) ? "opacity-50" : "opacity-100", borderRadius: "4px", disabled: props.saving, type: "button", onClick: onSubmit }, t("Save")))));
};
exports.default = ChangeEmailAddressForm;
